<script>
  import { createEventDispatcher } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Button, TabContent, TabPane } from '@sveltestrap/sveltestrap';

  import { ActivityHistory } from '@client/components/activity-history';
  import { AudienceInsights } from '@client/components/audience-insights';
  import { WebsiteTracking } from '@client/components/website-tracking';

  import { AttachmentsTab, People, Tags } from './tabs';

  export let row = {};
  export let tagFilters = {};
  export let showEntireHistory = {};

  let innerWidth = 0;
  let isMobile = false;
  let recipientFilter = null;

  const dispatch = createEventDispatcher();

  const onFetchHistory = () => {
    dispatch('row-fetch-history', {
      ...row
    });
  };

  const onTab = (evt) => {
    switch (evt.detail) {
      case 'attachment-tracking':
        initAttachments = true;
        break;
      case 'website-tracking':
        initWebsiteTracking = true;
        break;
      case 'audience-insights':
        initAudience = true;
        break;
    }
  };

  const onTagsChange = ({ detail }) =>
    dispatch('row-updated', {
      ...row,
      tags: detail.tags
    });

  let initAttachments = false;
  let initWebsiteTracking = false;
  let initAudience = false;

  $: hasAttachments =
    row.activityTypes['attachment-tracked'] ||
    row.activityTypes['attachmentdownload-downloaded'] ||
    row.activityTypes['attachmentview-viewerlaunched'];
  $: hasWebsiteTracking = row.activityTypes['websitevisit-visited'];

  $: isMobile = innerWidth <= 600;
</script>

<svelte:window bind:innerWidth />

<div class="activity-details">
  <div class="activity-details-tabs">
    <TabContent on:tab={onTab} pills>
      <TabPane tabId="history" tab={$format('label.HISTORY')} active>
        <ActivityHistory bind:data={row.activity} bind:recipientFilter allowReporting />
      </TabPane>
      {#if hasAttachments}
        <TabPane
          tabId="attachment-tracking"
          tab={isMobile ? $format('label.ATTACHMENT') : `${$format('label.ATTACHMENT')} ${$format('label.TRACKING')}`}
        >
          {#if initAttachments}
            <AttachmentsTab bind:row bind:recipientFilter />
          {/if}
        </TabPane>
      {/if}
      {#if hasWebsiteTracking}
        <TabPane
          tabId="website-tracking"
          tab={isMobile ? $format('label.WEBSITE') : `${$format('label.WEBSITE')} ${$format('label.TRACKING')}`}
        >
          {#if initWebsiteTracking}
            <WebsiteTracking bind:row bind:recipientFilter />
          {/if}
        </TabPane>
      {/if}
      <TabPane
        tabId="audience-insights"
        tab={isMobile ? $format('label.AUDIENCE') : `${$format('label.AUDIENCE')} ${$format('label.INSIGHTS')}`}
      >
        {#if initAudience}
          <AudienceInsights bind:row bind:recipientFilter isInsights />
        {/if}
      </TabPane>
      {#if !showEntireHistory[row.msglink]}
        <div class="fetch-history">
          <Button kind="secondary" size="sm" on:click={onFetchHistory}>{$format('label.LOAD_ENTIRE_HISTORY')}</Button>
        </div>
      {/if}
    </TabContent>
  </div>
  <div>
    <People bind:row bind:recipientFilter />
    <Tags on:tags={onTagsChange} bind:row bind:tagFilters />
  </div>
</div>

<style lang="scss" src="./row-expansion.scss"></style>
